export default __webpack_public_path__ + "images/60_1_image.jpg";